/* istanbul ignore file */

const googleDriveIcon = (
  <svg
    width={27}
    height={24}
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Google Drive</title>
    <g clipPath="url(#prefix-google-drive)">
      <path
        d="M2.03 20.57l1.185 2.045c.247.431.6.77 1.016 1.016l4.23-7.323H0c0 .477.123.954.37 1.384l1.66 2.877z"
        fill="#0066DA"
      />
      <path
        d="M13.43 7.692L9.2.37c-.415.247-.77.585-1.015 1.016L.369 14.923A2.787 2.787 0 000 16.308h8.462l4.969-8.616z"
        fill="#00AC47"
      />
      <path
        d="M22.63 23.63c.416-.245.77-.584 1.016-1.015l.492-.846 2.354-4.077c.246-.43.37-.907.37-1.384h-8.463l1.801 3.538 2.43 3.785z"
        fill="#EA4335"
      />
      <path
        d="M13.43 7.692L17.663.37A2.705 2.705 0 0016.276 0h-5.692c-.493 0-.97.138-1.385.37l4.23 7.322z"
        fill="#00832D"
      />
      <path
        d="M18.4 16.308H8.46l-4.23 7.323c.415.246.892.369 1.384.369h15.631c.492 0 .97-.139 1.385-.37L18.4 16.309z"
        fill="#2684FC"
      />
      <path
        d="M22.585 8.154l-3.908-6.77c-.246-.43-.6-.769-1.015-1.015L13.43 7.692l4.97 8.616h8.445c0-.477-.123-.954-.369-1.385l-3.892-6.77z"
        fill="#FFBA00"
      />
    </g>
    <defs>
      <clipPath id="prefix-google-drive">
        <path fill="#fff" d="M0 0h26.861v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default googleDriveIcon;
